kv.controller('efacturaFieldsConfigurationCtrl', function ($uibModalInstance, params, $scope, $http, $injector, resource) {
    let vm = new modalCtrl($uibModalInstance, $injector, 'efactura_configuration', 'id', $scope, params);

    vm.modal.rendered.then(() => {
        if (!vm.dataHasLoaded) KApp.block('.modal-content');
    });


    /**
     * Get the settings
     */
    vm.rest.get({
        url: 'efactura_configuration/' + vm.params.type + '/' + vm.params.entity_id,
    }).then(function (data) {
        KApp.unblock('.modal-content');
        vm.data = data.data;
        vm.fields = data.fields;
    });

    /**
     * Save the settings
     */
    vm.saveSettings = function ()
    {
        let postData = vm.data;
        vm.rest.post({
            url: 'efactura_configuration/' + vm.params.type + '/' + vm.params.entity_id,
            data: postData
        }).then(function (response) {
            if (response.status || response.status === undefined) {
                vm.close();
            }
        });
    }


    return vm;
});
